module.exports = __webpack_public_path__ + "static/Group 4-f16c8c526ff490d04ea8818e6d38c72e.png";